import type { ChannelFilters } from 'stream-chat';
import { ChatFilterState } from '../types';

type Params = {
  base: ChannelFilters;
  ui: ChatFilterState;
};

export function composeChannelFilters({ base, ui }: Params): ChannelFilters {
  const uiFilters: ChannelFilters = {};

  if (ui.organTypes.length) {
    uiFilters.organ_type = { $in: ui.organTypes };
  }

  if (ui.donorTypes.length) {
    uiFilters.donor_type = { $in: ui.donorTypes };
  }

  if (ui.chatTypes.length) {
    uiFilters.type = { $in: ui.chatTypes };
  }

  if (ui.unreadOnly) {
    uiFilters.has_unread = true;
  }

  if (Object.keys(uiFilters).length === 0) {
    return base;
  }

  const hasCollision = Object.keys(uiFilters).some((key) => key in base);
  if (hasCollision) {
    return { $and: [base, uiFilters] };
  }

  return { ...base, ...uiFilters };
}
